import React, { useState } from "react";
import $ from "jquery";
import moment from "moment/moment";

const FilterModalMissedCall = ({
  closeModal,
  filterModalDescTxt,
  setFilterData,
  filterData,
  setApiCalled,
  getFilterData,
  dateError,
  setDateError,
  error,
  setError,
  // setOutgoingData,
  Cdr,
  loader,
  callerId
}) => {
  const handleStartDateErrors = (value) => {
    setError("");
    if (filterData?.end_date === null) {
      setDateError("End Date is Missing");
    }
    if (filterData?.end_date !== null && value !== "") {
      if (value > filterData?.end_date) {
        setDateError("Start date must be lesser than end date");
      } else {
        setDateError("");
      }
    }
  };
  const handleEndDateErrors = (value) => {
    setError("");
    if (filterData?.start_date === null) {
      setDateError("Start Date is Missing");
    }
    if (filterData?.start_date !== null && value !== "") {
      if (value < filterData?.start_date) {
        setDateError("End date must be greater than Start date");
      } else {
        setDateError("");
      }
    }
  };

  const clearFilter = () => {
    // setLoader(true);
    $("#fromDate").val("");
    $("#toDate").val("");
    setApiCalled(true);
    setFilterData({
      start_date: null,
      end_date: null,
      caller_id: "",
      message: "",
     });
  };

  
  return (
    <div
      className="customModal ModalStyle uk-flex-top uk-open uk-flex uk-flex uk-open"
      uk-modal="esc-close: false; bg-close: false"
    >
      <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <div className="filterModalContent">
          <div className="modalHeading">
            <h4>Search filter</h4>
          </div>
          <div className="modalForm">
            <div className="formHeading">
              <span>{filterModalDescTxt}</span>
            </div>
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="uk-grid uk-grid-small" uk-grid="">
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="from_date">Start date</label>
                    <input
                      id="fromDate"
                      type="date"
                      value={filterData?.start_date}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          start_date: e.target.value,
                        });
                        handleStartDateErrors(e.target.value);
                      }}
                      className="uk-input"
                    />
                  </div>
                </div>
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="to_date">End date</label>
                    <input
                      id="toDate"
                      type="date"
                      value={filterData?.end_date}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          end_date: e.target.value,
                        });
                        handleEndDateErrors(e.target.value);
                      }}
                      className="uk-input"
                    />
                  </div>
                </div>
                {dateError !== "" && (
                  <div className="uk-width-1-1 formErrors">{dateError}</div>
                )}
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="agent">Msisdn</label>
                    <input
                      type="text"
                      placeholder="please enter msisdn number"
                      defaultValue={filterData.caller_id}
                      className="uk-input"
                      onChange={(e) => {
                        if (e.target.value !== "") {
                          setError("");
                        }
                        setFilterData({
                          ...filterData,
                          caller_id: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="type">Call Type</label>
                    <select
                      name="type"
                      value={filterData.call_type}
                      onChange={(e) => {
                        if (e.target.value !== "") {
                          setError("");
                        }
                        setFilterData({
                          ...filterData,
                          message: e.target.value,
                        });
                      }}
                      className="uk-select"
                    >
                      <option value="" selected disabled>
                        please select duration type
                      </option>
                        {callerId.map((val, index) => {
                          return (
                            <option key={index} value={val.call_status}>
                              {val.call_status}
                            </option>
                          );
                        })}
                    
                      
                    </select>
                  </div>
                </div>
                {error !== "" && (
                  <div className="uk-width-1-1 formErrors">{error}</div>
                )}
                <div className="uk-width-1-2">
                  <div className="clearFilterBtn">
                    {/* <button
                      className="exportData-button"
                      style={{ margin: "0px" }}
                      type="button"
                      onClick={() => clearFilter()}
                    >
                      Clear filter
                    </button> */}
                    <button
                      className="exportData-button"
                      style={{ margin: "0px" }}
                      type="button"
                      onClick={() => clearFilter()}
                    >
                      {/* {loader ? (
                        <div uk-spinner="" className="loader">
                          Clearing
                        </div>
                      ) : (
                        " Clear filter"
                      )} */}
                      Clear filter
                    </button>
                  </div>
                </div>
                <div className="uk-width-1-2">
                  <div className="btnwrp" style={{ float: "right" }}>
                    <button
                      type="button"
                      className="exportData-button"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="exportData-button"
                      onClick={() => {
                        // setOutgoingData([]);
                        getFilterData();
                      }}
                    >
                      {loader ? (
                        <div
                          uk-spinner=""
                          className="loader loaderfilter"
                        ></div>
                      ) : (
                        "Search"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModalMissedCall;
